// extracted by mini-css-extract-plugin
module.exports = {"section":"service-section_section__LrQQ5","service_section_padding":"service-section_service_section_padding__h4N_X"};